import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import cn from 'classnames';
import { Modal } from 'react-bootstrap';
import EventListener from 'react-event-listener';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { isPlainObject } from 'lodash';
import UMOGallery from '../UMOGallery';
import Nav from '../Nav';
import WorkspacePreview from '../WorkspacePreview';
import UMODetailModal from '../UMODetailModal';
import WorkspaceDetailModal from '../WorkspaceDetailModal';
import WorkspaceEmailDialog from '../WorkspaceEmailDialog';
import UMOModifyDialog from '../UMOModifyDialog';
import CategoryMoveDialog from '../CategoryMoveDialog';
import MessageDialog from '../MessageDialog';
import ShareLinkDialog from '../UMOShareLinkView';
import MetaAttach from '../MetaAttach';
import Loader from '../ui/Loader';
import appConfig from '../../appConfig';
import Header from '../Header';
import {
  logout,
  retrieveCollections,
  retrieveMetatags,
} from '../../actions/session';
import { addMetadata } from '../../actions/metaAttach';
import { isWorkbench } from '../../utils/piction';
import { showSearch } from '../../utils/uiUtils';
import {
  toggleNavPanel,
  toggleWorkspacePreview,
  toggleAdvancedSearch,
  toggleUMODetailView,
  toggleWorkspaceDetailView,
  showHighlightsAsMain,
  toggleFullImageView,
  toggleMetaPanelView,
} from '../../actions/mainUI';
import {
  deselectAll,
  retrieveBaseSearch,
  retrieveExternalSearch,
  retrieveUMOs,
  setLastSelectedUMOID,
} from '../../actions/umoGallery';
import * as mainContentTypes from '../../constants/mainContentTypes';
import { LABEL_DISCOVERER, LABEL_WORKBENCH } from '../../constants/labels';
import { addError } from '../../actions/messageDialog';
import SearchAdvanced from '../SearchBar/SearchAdvanced';
import PortalPublish from '../PortalPublish';
import EditHistory from '../EditHistory';
import DownloadList from '../DownloadList';
import { LOCAL_STORAGE_EXT_SEARCH } from '../../constants/session';
import DialogView from '../MainDialogModal';
import UMODetailViewFullImage from '../UMODetailView/UMODetailViewFullImage';
import { SelectableGroup } from '../../utils/drag-selector';
import { setSelectedUMOIDs } from '../../actions/umoGallery';
import FilesUploader from '../FilesUploader';
import { CATEGORY_UPLOADER } from '../FilesUploader/constants';
import BulkMetaEdit from '../BulkMetaEdit';
import classNames from 'classnames';

const mapStateToProps = (state) => ({
  session: state.session,
  mainUI: state.mainUI,
  umoGallery: state.umoGallery,
  workspacePreview: state.workspacePreview,
  metaAttach: state.metaAttach,
});

const mapDispatchToProps = (dispatch) => ({
  logoutDispatch: () => {
    dispatch(logout());
  },
  toggleWorkspaceDispatch: (isShown) =>
    dispatch(toggleWorkspacePreview(isShown)),
  toggleAdvancedSearch: (isShown) => dispatch(toggleAdvancedSearch(isShown)),
  toggleNavDispatch: (isShown) => dispatch(toggleNavPanel(isShown)),
  toggleUMODetailViewDispatch: (isShown) =>
    dispatch(toggleUMODetailView(isShown)),
  toggleWorkspaceDetailViewDispatch: (isShown) =>
    dispatch(toggleWorkspaceDetailView(isShown)),
  toggleFullImageViewDispatch: (isShown) =>
    dispatch(toggleFullImageView(isShown)),
  retrieveUMOsDispatch: (searchParams) => dispatch(retrieveUMOs(searchParams)),
  retrieveCollectionsDispatch: () => dispatch(retrieveCollections()),
  retrieveMetatagsDispatch: (collectionID) =>
    dispatch(retrieveMetatags(collectionID)),
  showHighlightsAsMain: () => dispatch(showHighlightsAsMain()),
  showHomeScreen: () => {
    dispatch(showHighlightsAsMain());
    dispatch(retrieveBaseSearch());
  },
  dispatch: (actionToDispatch) => dispatch(actionToDispatch),
});

class Main extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isExternalContentLoading: false,
      showTopButton: false,
    };

    this.onExternalContentMessage = this.onExternalContentMessage.bind(this);
    this.onExternalContentLoaded = this.onExternalContentLoaded.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.scrollToTop = this.scrollToTop.bind(this);
    this.onLogin = this.onLogin.bind(this);
    this.homeScreenRefresh = this.homeScreenRefresh.bind(this);
    this.onMouseDragSelectUMOs = this.onMouseDragSelectUMOs.bind(this);
  }

  componentDidMount() {
    this.onLogin();
  }

  componentDidUpdate(prevProps) {
    // Allow a component to refresh on new login
    // was added to address an issue when logging in with bookmark for public user
    // (because the bookmark is already on /home - the component wasn't refreshing)
    if (
      prevProps.session.get('token') === null &&
      prevProps.session.get('token') !== this.props.session.get('token')
    ) {
      this.onLogin();
    }

    // below prevents the loading indicator from showing if the same url is being launched.
    // this is required because the iframe won't get reloaded and the loading indicator ends
    // up staying on. bit hacky but will do for now.
    if (
      this.props.mainUI.get('mainContentType') ===
        mainContentTypes.EXTERNAL_URL &&
      this.props.mainUI.getIn(['mainContentData', 'url']) !==
        prevProps.mainUI.getIn(['mainContentData', 'url'])
    ) {
      this.setState({ isExternalContentLoading: true });
      
      const url = this.props.mainUI.getIn(['mainContentData', 'url']);
      const $extForm = document.getElementById('external-content__form');
      const $iframe = document.querySelector('iframe[name="external-content-iframe"]');
      
      if ($extForm && $iframe && url) {
        $extForm.target = 'external-content-iframe';
        $extForm.action = url;
        $extForm.method = 'POST';
        $extForm.submit();
      }
    }
  }

  onLogin() {
    // ability to add a custom title to the piction tab, or regular use of workbench/discoverer
    const pageTitle = this.props.session.get('isWorkbench')
      ? LABEL_WORKBENCH
      : LABEL_DISCOVERER;
    document.title = appConfig.tabTitle ? appConfig.tabTitle : pageTitle;
    const externalSearch = sessionStorage.getItem(LOCAL_STORAGE_EXT_SEARCH);
    if (externalSearch) {
      this.props.dispatch(retrieveExternalSearch(externalSearch));
      sessionStorage.removeItem(LOCAL_STORAGE_EXT_SEARCH);
    } else if (appConfig.initialQuery) {
      this.props.dispatch(retrieveBaseSearch());
    } else if (appConfig.useHighlights) {
      this.props.showHighlightsAsMain();
    }

    if (
      this.props.session.get('collectionList').size === 1 &&
      !this.props.session.get('isRequestingCollections')
    ) {
      this.props.retrieveCollectionsDispatch().then((res) => {
        const collectionList = res && res.res && res.res.a && res.res.a.rs;
        if (
          collectionList &&
          Array.isArray(collectionList) &&
          collectionList.length > 0
        ) {
          collectionList.forEach((col) =>
            this.props.retrieveMetatagsDispatch(col.$.info)
          );
        }
      });
    }
  }

  // handler for the external content -- i.e. content in iframe
  onExternalContentMessage(e) {
    if (e && isPlainObject(e.data)) {
      switch (e.data.kauiAction) {
        case 'EXIT':
          showSearch(this.props.dispatch);
          // refresh the umoGallery component by redoing the query. this is just a quick way to
          // reinitialise the gallery because the justified gallery doesn't appear correctly
          // when it gets remounted.
          this.props.dispatch(retrieveUMOs());
          break;
        case 'META_ATTACH':
          this.props.dispatch(addMetadata(e.data.metadata));
          showSearch(this.props.dispatch);
          this.props.dispatch(retrieveUMOs());
          break;
        case 'MESSAGE':
          this.props.dispatch(addError(e.data.message));
          break;
        default:
          break;
      }
    }
  }

  onExternalContentLoaded() {
    this.setState({ isExternalContentLoading: false });
  }

  getMainContent() {
    switch (this.props.mainUI.get('mainContentType')) {
      case mainContentTypes.BULK_META_EDIT:
        return <BulkMetaEdit homeScreenRefresh={this.homeScreenRefresh} />;
      case mainContentTypes.SEARCH_UMO:
        return (
          <div>
            <UMOGallery />
          </div>
        );
      case mainContentTypes.EXTERNAL_URL:
        return (
          <div className="external-content">
            <EventListener
              target="window"
              onMessage={this.onExternalContentMessage}
            />
            {(this.props.mainUI.getIn(['mainContentData', 'isLoading']) ||
              this.state.isExternalContentLoading) && (
              <div className="external-content__loader">
                <Loader isLarge />
              </div>
            )}
            <iframe
              name="external-content-iframe"
              onLoad={this.onExternalContentLoaded}
              src={null}
              height="100%"
              width="100%"
            />
          </div>
        );
      case mainContentTypes.ADMIN_SCREEN:
        let contentData = null;
        // in switch for future admin screens
        switch (this.props.mainUI.getIn(['mainContentData', 'screenType'])) {
          case mainContentTypes.ADMIN_PUBLISH:
            contentData = <PortalPublish />;
            break;
        }
        return <div className="local-admin-content">{contentData}</div>;
      case mainContentTypes.RECORD_SCREEN:
        // in switch for future record screens
        switch (this.props.mainUI.getIn(['mainContentData', 'screenType'])) {
          case mainContentTypes.EDIT_HISTORY:
            return (
              <div className="local-admin-content">
                <EditHistory />
              </div>
            );
          case mainContentTypes.DOWNLOAD_LIST:
            return (
              <div className="local-admin-content">
                <DownloadList />
              </div>
            );
          default:
            return null;
        }
      case mainContentTypes.EXTERNAL_ADMIN_SCREEN:
        return (
          <div className="admin-content">
            <EventListener
              target="window"
              onMessage={this.onExternalContentMessage}
            />
            {(this.props.mainUI.getIn(['mainContentData', 'isLoading']) ||
              this.state.isExternalContentLoading) && (
              <div className="external-content__loader">
                <Loader isLarge />
              </div>
            )}
            <iframe
              name="external-content-iframe"
              onLoad={this.onExternalContentLoaded}
              src={this.props.mainUI.getIn(['mainContentData', 'url'])}
              height="100%"
              width="100%"
            />
          </div>
        );
      default:
        return null;
    }
  }

  handleScroll(e) {
    const $elem = e.target;
    if ($elem.scrollTop > 300) this.setState({ showTopButton: true });
    else if ($elem.scrollTop < 300) this.setState({ showTopButton: false });
  }

  scrollToTop() {
    document.querySelector('.main__body').scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
    this.setState({ showTopButton: false });
  }

  homeScreenRefresh() {
    this.props.toggleNavDispatch(false);
    this.props.showHomeScreen();
    this.props.dispatch(toggleMetaPanelView(false));
    this.props.dispatch(deselectAll());
    this.scrollToTop();
  }

  /**
   * Update the selected UMO ids when umos are selected though mouse drag selection
   * @param {Array} selectedKeys umoids of slected umos through mouse drag selection
   */
  onMouseDragSelectUMOs(selectedKeys) {
    this.props.dispatch(setSelectedUMOIDs(selectedKeys));
    if (selectedKeys.length >= 0)
      this.props.dispatch(
        setLastSelectedUMOID(selectedKeys[selectedKeys.length - 1])
      );
  }

  render() {
    const topScrollTooltip = (
      <Tooltip id="tooltip">
        <FormattedMessage id="general.scrollToTop" />
      </Tooltip>
    );
    return (
      <div className="main">
        <form
          id="external-content__form"
          action={this.props.mainUI.getIn(['mainContentData', 'url'])}
          method="post"
          target="external-content-iframe"
        >
          <input
            type="hidden"
            name="surl"
            value={this.props.session.get('surl') || ''}
          />
          <input
            type="hidden"
            name="csrf"
            value={this.props.session.get('token') || ''}
          />
        </form>
        <DialogView />
        <MessageDialog />
        <UMODetailModal
          umoID={this.props.mainUI.get('shownUMODetailView')}
          toggleUMODetailView={this.props.toggleUMODetailViewDispatch}
          dispatch={this.props.dispatch}
          retrieveUMOs={retrieveUMOs}
          selectedWorkspaceData={{
            id: this.props.workspacePreview.get('selectedID'),
            name: this.props.workspacePreview.getIn(['selectedData', 'name']),
            description: this.props.workspacePreview.getIn([
              'selectedData',
              'description',
            ]),
          }}
        />
        <WorkspaceDetailModal
          modalWorkspaceID={this.props.mainUI.get('modalWorkspaceID')}
          umoID={this.props.mainUI.get('shownWorkspaceDetailView')}
          toggleWorkspaceDetailView={
            this.props.toggleWorkspaceDetailViewDispatch
          }
          dispatch={this.props.dispatch}
          retrieveUMOs={retrieveUMOs}
          cardURL={appConfig.cardURL}
          username={this.props.session.get('username')}
        />
        <UMODetailViewFullImage
          isFullImageShown={this.props.mainUI.get('isFullImageViewShown')}
          onFullImageToggle={this.props.toggleFullImageViewDispatch}
          umoData={this.props.mainUI.get('fullImageUmoData')}
        />
        <Modal
          size="xl"
          show={this.props.mainUI.get('isAdvancedSearchShown')}
          onHide={this.props.toggleAdvancedSearch}
          className="search-advanced-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <FormattedMessage id="searchBar.advancedSearch" />
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <SearchAdvanced
              dispatch={this.props.dispatch}
              userCollection={this.props.session.get('userCollection')}
              collectionList={this.props.session.get('collectionList')}
              isRequestingCollections={this.props.session.get(
                'isRequestingCollections'
              )}
              collectionsError={
                this.props.session.get('collectionsRequest') instanceof Error
                  ? this.props.session.get('collectionsRequest')
                  : undefined
              }
              metatags={this.props.session.get('metatags')}
              savedSearches={this.props.umoGallery.get('savedSearches')}
              isAdvancedSearchShown={this.props.mainUI.get(
                'isAdvancedSearchShown'
              )}
              onAdvancedSearchToggle={this.props.toggleAdvancedSearch}
              isPublicUsr={this.props.session.get('acctType') === 'G'}
              searchParams={this.props.umoGallery.get('searchParams')}
            />
          </Modal.Body>
        </Modal>
        <WorkspaceEmailDialog
          isShown={!!this.props.mainUI.get('emailWorkspaceData')}
          selectedWorkspaceData={
            this.props.mainUI.get('emailWorkspaceData') &&
            this.props.mainUI.get('emailWorkspaceData').toJS()
          }
          isPortal={this.props.workspacePreview.get('isPortal')}
        />
        <UMOModifyDialog
          isShown={!!this.props.mainUI.get('UMOModifyData')}
          workspaceID={this.props.mainUI.get('modalWorkspaceID')}
          umoList={this.props.mainUI.get('umoList')}
          data={this.props.mainUI.get('UMOModifyData')}
          searchParams={this.props.umoGallery.get('searchParams')}
        />
        <CategoryMoveDialog
          isShown={!!this.props.mainUI.get('categoryToMoveID')}
          categoryID={this.props.mainUI.get('categoryToMoveID')}
          categoryName={this.props.mainUI.get('categoryToMoveName')}
        />
        <div
          className={cn('main__header', {
            'main__header--wb': true,
          })}
        >
          <Header
            username={this.props.session.get('username')}
            locale={this.props.session.get('locale')}
            logout={this.props.logoutDispatch}
            onWorkspaceToggle={this.props.toggleWorkspaceDispatch}
            onAdvancedSearchToggle={this.props.toggleAdvancedSearch}
            isWorkspacePreviewShown={this.props.mainUI.get(
              'isWorkspacePreviewShown'
            )}
            isAdvancedSearchShown={this.props.mainUI.get(
              'isAdvancedSearchShown'
            )}
            selectedWorkspaceName={this.props.workspacePreview.getIn([
              'selectedData',
              'name',
            ])}
            selectedWorkspaceID={this.props.workspacePreview.get('selectedID')}
            dispatch={this.props.dispatch}
            searchParams={this.props.umoGallery.get('searchParams')}
            isWorkbench={this.props.session.get('isWorkbench')}
            onHomeClick={this.homeScreenRefresh}
          />
        </div>
        <div className="main__workspace-preview">
          <WorkspacePreview
            workspacePreview={this.props.workspacePreview}
            isWorkspaceExpanded={this.props.mainUI.get(
              'isWorkspacePreviewShown'
            )}
            onWorkspaceToggle={this.props.toggleWorkspaceDispatch}
            dispatch={this.props.dispatch}
            umoList={this.props.umoGallery.get('umoList')}
          />
        </div>
        <Nav
          isWorkspaceExpanded={this.props.mainUI.get('isWorkspacePreviewShown')}
          isNavExpanded={this.props.mainUI.get('isNavPanelShown')}
          onNavExpand={this.props.toggleNavDispatch}
          dispatch={this.props.dispatch}
          scrollToTop={this.scrollToTop}
          onHomeClick={this.homeScreenRefresh}
        />
        <SelectableGroup
          onEndSelection={this.onMouseDragSelectUMOs}
          tolerance={10}
          fixedPosition={true}
          enabled={
            appConfig.isDragSelectionEnabled &&
            !this.props.umoGallery.get('isFilterExpanded') &&
            !this.props.mainUI.get('categoryToUpload')?.isFileUploaderMounted &&
            !(
              this.props.mainUI.get('mainContentType') ===
              mainContentTypes.BULK_META_EDIT
            )
          }
        >
          <div
            className={cn('main__body', {
              'main__body--open': this.props.mainUI.get('isNavPanelShown'),
              'main__body--external-content':
                this.props.mainUI.get('mainContentType') ===
                  mainContentTypes.EXTERNAL_URL ||
                this.props.mainUI.get('mainContentType') ===
                  mainContentTypes.ADMIN_SCREEN,
              'main__body--workspace-open': this.props.mainUI.get(
                'isWorkspacePreviewShown'
              ),
            })}
            onScroll={this.handleScroll}
          >
            {this.getMainContent()}
            {this.props.mainUI.getIn(['fileUploader', 'showFileUploader']) ===
              true && (
              <div
                className={classNames([
                  'photo-uploader-wrapper',
                  this.props.mainUI.getIn(['fileUploader', 'isMinimized']) &&
                    'photo-uploader-wrapper-minimized',
                  this.props.mainUI.getIn(['fileUploader', 'isCollapsed']) &&
                    'photo-uploader-wrapper-collapsed',
                ])}
              >
                <FilesUploader homeScreenRefresh={this.homeScreenRefresh} />
              </div>
            )}
          </div>
        </SelectableGroup>
        {this.state.showTopButton ? (
          <OverlayTrigger placement="top" overlay={topScrollTooltip}>
            <Button onClick={this.scrollToTop} className="back-to-top__button">
              <i className="back-to-top__button-icon" />
            </Button>
          </OverlayTrigger>
        ) : null}
      </div>
    );
  }
}

Main.contextTypes = {
  router: PropTypes.object,
};

Main.propTypes = {
  logoutDispatch: PropTypes.func,
  toggleWorkspaceDispatch: PropTypes.func,
  toggleAdvancedSearch: PropTypes.func,
  toggleNavDispatch: PropTypes.func,
  toggleUMODetailViewDispatch: PropTypes.func,
  toggleWorkspaceDetailViewDispatch: PropTypes.func,
  toggleFullImageViewDispatch: PropTypes.func,
  retrieveCollectionsDispatch: PropTypes.func,
  retrieveMetatagsDispatch: PropTypes.func,
  dispatch: PropTypes.func,
  session: PropTypes.instanceOf(Map),
  umoGallery: PropTypes.instanceOf(Map),
  mainUI: PropTypes.instanceOf(Map),
  workspacePreview: PropTypes.instanceOf(Map),
  metaAttach: PropTypes.instanceOf(Map),
  showHighlightsAsMain: PropTypes.func,
  showHomeScreen: PropTypes.func,
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(Main));
